import { render } from "./PlatformManual.vue?vue&type=template&id=5614fdfe&scoped=true"
import script from "./PlatformManual.vue?vue&type=script&lang=js"
export * from "./PlatformManual.vue?vue&type=script&lang=js"

import "./PlatformManual.vue?vue&type=style&index=0&id=5614fdfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5614fdfe"]])

export default __exports__